import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Breakpoint } from '../global/global-interfaces';

@Injectable({
  providedIn: 'root',
})
export class SizeService {
  private readonly resizeSubject: BehaviorSubject<Breakpoint> = new BehaviorSubject(this.resolveScreensizeClass(window.innerWidth));
  public screenSize: Breakpoint = this.resizeSubject.getValue();

  constructor() {
    fromEvent(window, 'resize')
      .pipe(debounceTime(10))
      .subscribe(() => {
        const size = this.resolveScreensizeClass(window.innerWidth);
        if (size) {
          this.screenSize = size;
          this.resizeSubject.next(size);
        }
      });
  }

  onResize$(): Observable<Breakpoint> {
    return this.resizeSubject.asObservable();
  }

  private resolveScreensizeClass(x: number): Breakpoint {
    if (x >= 1920) { return 'xxxl'; }
    if (x >= 1536) { return 'xxl'; }
    if (x >= 1280) { return 'xl'; }
    if (x >= 1024) { return 'lg'; }
    if (x >= 768) { return 'md'; }
    if (x >= 640) { return 'sm'; }
    return 'xs';
  }

  checkScreensize(allowedSizes: Breakpoint[]): boolean {
    return allowedSizes.length === 0 || allowedSizes.includes(this.screenSize);
  }
}
